import CrudTab from "react/containers/pages/CrudTab";
import { fixGridAndFilterBuilder } from "react/utils/utils";

class Route extends CrudTab {
  renderNestedRouter = crudParams => {
    const [, parentEntity, parentId, nested, mode, id] = crudParams;

    if (!App.Forms.Route && parentEntity === "Route") {
      const parentRouter = new App.Routers.Route();
      switch (mode) {
        case "edit":
          Monet.Session.Route.stopEditingId = id;
          break;
        case "new":
          Monet.Session.Route.isAddingStop = true;
          break;
      }
      parentRouter.goToEditRoute(parentId);
      return;
    }

    const RouterClass = App.Routers[nested];
    if (RouterClass) {
      App.Objects[nested] = new RouterClass();
      const router = App.Objects[nested];
      switch (mode) {
        case "edit":
          router.edit(parentId, id);
          break;
        case "new":
          router.form_new(parentId, id);
          break;
        default:
          router.list();
          break;
      }
    }
  };

  componentDidMount() {
    const {
      tab: { pathname }
    } = this.props;
    const crudParams = pathname.split("/");

    Monet.Session.Route = {
      stopEditingId: null,
      isAddingStop: false
    };

    if (crudParams.length > 4) {
      this.renderNestedRouter(crudParams);
    } else {
      super.componentDidMount();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      active,
      tab: { pathname }
    } = this.props;
    const crudParams = pathname.split("/");
    const isComingFromAnotherTab = active !== prevProps.active;
    const didChangeTab = pathname !== prevProps.tab.pathname;
    const forceUpdate = isComingFromAnotherTab && didChangeTab;

    if (isComingFromAnotherTab && active) {
      fixGridAndFilterBuilder();
    }

    if ((!isComingFromAnotherTab && active && didChangeTab) || forceUpdate) {
      if (crudParams.length > 4) {
        this.renderNestedRouter(crudParams);
      } else {
        super.componentDidUpdate(prevProps, forceUpdate);
      }
    }
  }
}

export default Route;
